import webBiLogger from '@wix/web-bi-logger';
import { metaSiteId } from '../fromWindow';
import { getAppUrl, getAppVersion } from '@wix/experts-common';

const logger = webBiLogger
  .factory()
  .updateDefaults({
    src: 80,
    msid: metaSiteId,
    appVersion: getAppVersion(getAppUrl('experts-feedback')),
  })
  .logger();

export default logger;
